/**
 * The technician's "Client-facing display name" setting (Gorelo > Settings > Users), as the branded
 * Client Portal shows it: the "(company)" suffix the emails carry is left out here, since the whole app
 * is already the company's. Mirrors Gorelo.Api.Shared.Naming.ClientFacingName on the backend and the
 * Messenger's copy of this file.
 */
export const ClientFacingNameSetting = {
  CompanyNameOnly: 1,
  FullNameWithCompany: 2,
  NicknameWithCompany: 3,
} as const

export interface ClientFacingNameSource {
  firstName?: string
  lastName?: string
  nickName?: string | null
  displayNameSetting?: number | null
}

export function resolveClientFacingName(
  person: ClientFacingNameSource | undefined,
  _companyName?: string | null,
): string | undefined {
  if (!person) return undefined
  const fullName = `${person.firstName ?? ""} ${person.lastName ?? ""}`.trim()
  const nickName = person.nickName?.trim()
  // Option 3 without a nickname (cleared after it was chosen) falls back to option 2.
  if (person.displayNameSetting === ClientFacingNameSetting.NicknameWithCompany && nickName) return nickName
  // Option 1 (company name) is for emails only; the branded apps show the technician's own name instead.
  return fullName || undefined
}
